var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTestingQaServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Testing_QA_Services_",
    "data-name": "Testing & QA Services ",
    transform: "translate(-69 -181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    width: 24,
    height: 24,
    transform: "translate(69 181)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_web_testing_1917658",
    "data-name": "noun_web testing_1917658",
    transform: "translate(61 175)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2315",
    "data-name": "Group 2315",
    transform: "translate(8 6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8867",
    "data-name": "Path 8867",
    d: "M29.333,6.889A.889.889,0,0,0,28.444,6H8.889A.889.889,0,0,0,8,6.889V8.667H29.333ZM9.778,7.778H8.889V6.889h.889Zm1.778,0h-.889V6.889h.889Zm1.778,0h-.889V6.889h.889Z",
    transform: "translate(-8 -6)",
    fill: "#22b573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8868",
    "data-name": "Path 8868",
    d: "M13.575,31.575,14.149,31H13v1.778h1.778V31.628L14.2,32.2Z",
    transform: "translate(-10.778 -19.889)",
    fill: "#22b573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8869",
    "data-name": "Path 8869",
    d: "M13.575,19.575,14.149,19H13v1.778h1.778V19.628L14.2,20.2Z",
    transform: "translate(-10.778 -13.222)",
    fill: "#22b573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8870",
    "data-name": "Path 8870",
    d: "M13.575,43.575,14.149,43H13v1.778h1.778V43.628L14.2,44.2Z",
    transform: "translate(-10.778 -26.556)",
    fill: "#22b573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8871",
    "data-name": "Path 8871",
    d: "M26.222,23.778a5.734,5.734,0,0,1,3.112.917V14H8V30a.889.889,0,0,0,.889.889H20.606a5.758,5.758,0,0,1,5.616-7.111ZM28,21.556H16.444v-.889H28ZM16.444,15.333H28v.889H16.444Zm-1.778,0h.889v.889h-.889Zm0,1.778H26.222V18H14.667Zm0,3.556h.889v.889h-.889Zm0,1.778H24v.889H14.667Zm0,3.556h.889v.889h-.889Zm-1.778.628v2.483a.444.444,0,0,1-.444.444H9.778a.444.444,0,0,1-.444-.444V26.444A.444.444,0,0,1,9.778,26H12.26l.759-.759.628.628Zm0-5.333v2.483a.444.444,0,0,1-.444.444H9.778a.444.444,0,0,1-.444-.444V21.111a.444.444,0,0,1,.444-.444H12.26l.759-.759.628.628Zm0-5.333v2.483a.444.444,0,0,1-.444.444H9.778a.444.444,0,0,1-.444-.444V15.778a.444.444,0,0,1,.444-.444H12.26l.759-.759.628.628Zm6.667,12.7H14.667v-.889h4.889ZM20,26.889H16.444V26H20Z",
    transform: "translate(-8 -10.444)",
    fill: "#22b573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8872",
    "data-name": "Path 8872",
    d: "M42.889,38a4.889,4.889,0,1,0,4.889,4.889A4.889,4.889,0,0,0,42.889,38Zm0,8.889a4,4,0,1,1,4-4A4,4,0,0,1,42.889,46.889Z",
    transform: "translate(-24.667 -23.778)",
    fill: "#22b573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8873",
    "data-name": "Path 8873",
    d: "M45.111,42a3.111,3.111,0,1,0,3.111,3.111A3.111,3.111,0,0,0,45.111,42Zm-.13,4.759a.444.444,0,0,1-.628,0l-1.333-1.333.628-.628,1.019,1.019,2.13-2.13.628.628Z",
    transform: "translate(-26.889 -26)",
    fill: "#22b573"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestingQaServices);
export default __webpack_public_path__ + "static/media/Testing-_QA_Services.b3e2de84ef98290eb892707e94faef16.svg";
export { ForwardRef as ReactComponent };